<mat-card appearance="outlined" class="sidebar-widget-card">
	<div class="sidebar-widget">
		<h3 class="sidebar-widget-header very-dark-header" (click)="widgetHeaderClick()">
			@if (icon) {
				<mat-icon svgIcon="{{ icon }}"></mat-icon>
			}
			<span>{{ heading }}</span>
			<mat-icon [svgIcon]="'acies_expand_right'" class="arrow-rotating" [ngClass]="{ 'arrow-rotating__opened': !collapsed }"></mat-icon>
		</h3>
		<div class="sidebar-widget-inner">
			<ng-content></ng-content>
		</div>
	</div>
</mat-card>
